import { render, staticRenderFns } from "./TabNotice.vue?vue&type=template&id=4475e393&scoped=true"
import script from "./TabNotice.vue?vue&type=script&lang=js"
export * from "./TabNotice.vue?vue&type=script&lang=js"
import style0 from "./TabNotice.vue?vue&type=style&index=0&id=4475e393&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475e393",
  null
  
)

export default component.exports